<template>
  <div style="padding: 0 15px">
    <div id="approveState" @click="visibleBox">
      <template v-if="!stateList || stateList.length == 0">
        <div class="empty-state">暂无审批信息</div>
      </template>
      <template v-else>
        <div v-bind:style="{width:(stateList.length * 250)+'px'}">
          <div v-for="(state,index) in stateList" :key="state.new_flowapproval_stepsId">
            <div class="node" :style="state.new_status !== 0 ? 'width:90px': ''" @click="onClick">
              <i v-if="state.new_status === 0" class="node-icon"
                 v-bind:class="{'icon-skip':state.new_status === 1 && state.new_name != '','icon-approving':state.new_status === 1 && state.new_name == '','icon-approved':state.new_status === 2,'icon-submit':state.new_status === 0}"></i>
              <div v-else
                   v-bind:class="{'icon-skip':state.new_status === 1 && state.new_name != '','icon-approving':state.new_status === 1 && state.new_name == '','icon-approved':state.new_status === 2,'icon-submit':state.new_status === 0}">
                {{state.new_stepName}}
              </div>

              <ul :style="state.new_status !== 0 ? 'margin-left:-50px': 'top: 55px'">
                <li v-if="!(state.new_approvalway===2 && state.list ) && !(state.new_approvalway===3 && state.list)" class="owner">
                  {{state.new_userName}}
                </li>
                <li v-if="state.new_status === 1 && state.list" style="color: #848383;">(点击查看审批人)</li>
                <template v-if="state.new_status === 1 && state.list">
                  <li v-if="state.new_approvalway==2" style="color: #848383;">所有审批人均需审批</li>
                  <li v-if="state.new_approvalway==3" style="color: #848383;">一人审批即可通过</li>
                </template>
                <template v-if="state.new_status === 2 && (state.new_approvalway==2 || state.new_approvalway==3)">
                  <li v-if="state.list">
                    <template v-for="(data, index) in state.list">
                      <span v-if="data.new_status === 2 ">{{index ? '，':''}}{{ data.new_userName }}</span>
                    </template>
                    已审批
                  </li>
                </template>
              </ul>
              <template v-if="state.list">
                <div ref="nodeBox" class="node-box" style="display: none;">
                  <div>
                    <div>处理人：</div>
                    <div style="width: 100%;padding-left: 15px;">
                      <div v-for="(data, index) in state.list" :key="index" style="width: 100%;">
                        <span class="new_userName">{{data.new_userName }}</span>
                        <template v-if="!(state.new_approvalway==3 && state.list[0].new_status === 2 && index)">
                          <span :class="{'status-color': data.new_status === 2,'status-color1':data.new_status === 1}">
                            {{data.new_status === 2 ? '已审批' : '待审批'}}
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="index !== stateList.length - 1" class="proce">
              <span>- - - - - - - - - - -</span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div id="approveTrack" @click="visibleBox">
      <h3>历史记录</h3>
      <ul>
        <li v-for="(track,index) in trackList" :key="track.new_flowapproval_logId" :class="{last: index === trackList.length - 1}">
          <div style="margin-top:0;">
            <i class="node-icon" v-bind:class="{first: index === 0}"></i>
            <div>
              <span class="date">{{track.new_date}}</span>
              <span class="action">[{{track.new_actionName}}]</span>
              <span class="step">{{track.new_stepName}}</span>
              <span class="owner">{{track.new_userName}}</span>
            </div>
            <div v-if="track.new_memo!=null && track.new_actionName!='驳回到指定步骤' && track.new_actionName!='驳回到申请人'"
                 class="memo"><span>[{{track.new_actionName}}意见]: {{track.new_memo}}</span></div>
            <div v-if="track.new_memo!=null && (track.new_actionName=='驳回到指定步骤' || track.new_actionName=='驳回到申请人')"
                 class="memo"><span>[驳回意见]: {{track.new_memo}}</span></div>
            <div v-if="track.new_result!=null" class="memo"><span>[驳回意见]: {{track.new_result}}</span></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RtApprovalProgress',
    data() {
      return {
        stateList: [],
        trackList: []
      }
    },
    props: {
      entityName: {
        type: String,
        require: true
      },
      entityId: {
        type: String,
        require: true
      }
    },
    mounted: function () {
      this.getStateList();
      this.getTrackList();
    },
    methods: {
      getStateList() {
        if (rt.isNullOrWhiteSpace(this.entityId)) {
          return;
        }
        rt.get("../api/CrmFlow/GetFlowApproveProgressList?entityName=" + this.entityName + "&entityId=" + this.entityId)
          .then((res) => {
            if (res == null || res.length == 0) {
              return;
            }
            let stateList = res;
            let staList = [], k = 0, oneList = [];
            // new_approvalway 默认：1，会签：2，或签：3，沟通：4
            // new_status 待审批：1，我审批：2
            while (k < stateList.length) {
              if (!oneList.length) {
                oneList.push(stateList[k]);
              } else {
                if (stateList[k].new_stepName === oneList[0].new_stepName && stateList[k].new_approvalway !== 1) {
                  oneList.push(stateList[k]);
                } else {
                  if (oneList.length > 1 && oneList[0].new_approvalway === 3) {
                    oneList.sort(function (a, b) {
                      if (a.new_date == null) {
                        return a.new_date > b.new_date ? -1 : 1;
                      }
                      else if (b.new_date == null) {
                        return a.new_date > b.new_date ? 1 : -1;
                      }
                    });
                  }
                  const o = oneList[0];
                  const isApproval = oneList.map(item => item.new_date).indexOf(null) !== -1;
                  const date = (isApproval && o.new_approvalway === 2) ? o.new_date : null;
                  const status = (isApproval && o.new_approvalway === 2) ? 1 : o.new_status;
                  staList.push({
                    new_approvalway: o.new_approvalway,
                    new_date: (isApproval && o.new_approvalway === 2) ? o.new_date : null,
                    new_flowapproval_stepsId: o.new_flowapproval_stepsId,
                    new_isnextstep: o.new_isnextstep,
                    new_result: o.new_result,
                    new_status: (isApproval && o.new_approvalway === 2) ? 1 : o.new_status,
                    new_stepName: o.new_stepName,
                    new_userName: o.new_userName,
                    new_name: (o.new_approvalway == 2 && status === 2) || (o.new_approvalway == 3 && date) ? '已跳过' : '',
                    list: oneList.length > 1 ? oneList : null
                  })

                  oneList = [stateList[k]];
                }
              }
              if (k + 1 === stateList.length && oneList.length) {
                if (oneList.length > 1 && oneList[0].new_approvalway === 3) {
                  oneList.sort(function (a, b) {
                    if (a.new_date == null) {
                      return a.new_date > b.new_date ? -1 : 1;
                    }
                    else if (b.new_date == null) {
                      return a.new_date > b.new_date ? 1 : -1;
                    }
                  });
                }
                const o = oneList[0];
                const isApproval = oneList.map(item => item.new_date).indexOf(null) !== -1;
                const date = (isApproval && o.new_approvalway === 2) ? o.new_date : null;
                const status = (isApproval && o.new_approvalway === 2) ? 1 : o.new_status;
                staList.push({
                  new_approvalway: o.new_approvalway,
                  new_date: date,
                  new_flowapproval_stepsId: o.new_flowapproval_stepsId,
                  new_isnextstep: o.new_isnextstep,
                  new_result: o.new_result,
                  new_status: status,
                  new_stepName: o.new_stepName,
                  new_userName: o.new_userName,
                  new_name: (o.new_approvalway == 2 && status === 2) || (o.new_approvalway == 3 && date) ? '已跳过' : '',
                  list: oneList.length > 1 ? oneList : null
                });
              }
              k++;
            }
            this.stateList = staList;

            //先给横的记录排序，按时间顺序
            let transverse = [];
            for (let i = 0; i < this.stateList.length; i++) {
              if (this.stateList[i].new_date != null) {
                transverse.push(this.stateList[i])
              }
            }

            transverse.sort(function (a, b) {//排序
              return a.new_date > b.new_date ? 1 : -1;
            });

            for (let i = 0; i < this.stateList.length; i++) {
              if (this.stateList[i].new_date == null) {
                transverse.push(this.stateList[i])
              }
            }
            this.trackList.sort(function (a, b) {//排序
              return a.new_date > b.new_date ? 1 : -1;
            });
          }).catch((error) => {
            rt.showErrorToast(error);
          });
      },
      getTrackList() {
        if (rt.isNullOrWhiteSpace(this.entityId)) {
          return;
        }
        rt.get("../api/CrmFlow/GetFlowApproveLogList?entityName=" + this.entityName + "&entityId=" + this.entityId)
          .then((res) => {
            this.trackList = res;
          }).catch((error) => {
            rt.showErrorToast(error);
          });
      },
      // 展示当前节点的审批人列表
      onClick(e) {
        e.stopPropagation();
        // console.log(e);
        const dom = e.currentTarget.children[2];
        if (dom) {
          if (dom.style.display === 'block') {
            this.$refs.nodeBox.forEach(item => item.style.display = "none")
            e.currentTarget.children[2].style.display = "none"
          } else {
            this.$refs.nodeBox.forEach(item => item.style.display = "none")
            e.currentTarget.children[2].style.display = "block"
          }
        } else {
          if (this.$refs.nodeBox) {
            this.$refs.nodeBox.forEach(item => item.style.display = "none")
          }
        }
      },
      // 隐藏审批节点框
      visibleBox() {
        if (this.$refs.nodeBox) {
          this.$refs.nodeBox.forEach(item => item.style.display = "none")
        }
      }
    }
  }
</script>


<style scope>
a {
  text-decoration: none;
}

ul li {
  list-style: none;
}

#approveState {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 25px 35px;
  height: 150px;
  border-bottom: 1px solid #cccccc;
}

#approveState .node {
  position: relative;
  top: 0;
  float: left;
  width: 50px;
  height: 50px;
  font-size: 14px;
  cursor: pointer;
}

#approveState .node .node-icon {
  position: absolute;
  display: block;
  left: 1px;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#approveState .icon-submit {
  background-image: url("data:image/png;base64,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");
}

#approveState .icon-approving {
  display: flex;
  align-items: center;
  width: 90px;
  min-height: 50px;
  padding: 5px 10px;
  text-align: center;
  box-sizing: border-box;
  background: #cccccc;
  color: #fff;
  border-radius: 4px;
  /* background-image: url("data:image/png;base64,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"); */
}

#approveState .icon-approved {
  display: flex;
  align-items: center;
  width: 90px;
  min-height: 50px;
  padding: 5px 10px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 4px;
  color: #000;
  background: #c5e29c;
  /* background-image: url("data:image/png;base64,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"); */
}

#approveState .icon-skip {
  display: flex;
  align-items: center;
  width: 90px;
  min-height: 50px;
  padding: 5px 10px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 4px;
  color: #000;
  background: #c5e29c;
  /* background-image: url("data:image/png;base64,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"); */
}


#approveState .proce {
  position: relative;
  float: left;
  top: 16px;
  margin: 0 10px;
  color: #888888;
}

#approveState .node ul {
  z-index: 1;
  width: 189px;
  margin-left: -70px;
  /* top: 55px; */
  position: absolute;
  text-align: center;
}

#approveState .node .node-box {
  position: absolute;
  top: 35px;
  left: 20px;
  width: 200px;
  height: 105px;
  padding: 5px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  line-height: 30px;
  border-radius: 4px;
  border: 1px solid #d6d6d6;
  background: #fff;
  z-index: 1111;
}

#approveState .node .node-box .new_userName {
  float: left;
  width: calc(100% - 74px);
  height: 30px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#approveState .node .status-color {
  padding: 0 5px;
  color: #fff;
  background: #24be58;
  border-radius: 4px;
}

#approveState .node .status-color1 {
  padding: 0 5px;
  color: #fff;
  background: #8c9990;
  border-radius: 4px;
}

#approveState .owner {
  font-size: 14px;
  color: #444444;
  margin-top: 5px;
}

#approveState .date {
  font-size: 14px;
  color: #444444;
  margin-top: 3px;
}

#approveTrack {
  margin-top: 20px;
}

#approveTrack ul {
  padding-top: 15px;
  padding-left: 15px;
  font-size: 14px;
}

#approveTrack ul li {
  position: relative;
  padding: 0 15px 20px 15px;
  border-left: 1px solid #d9d9d9;
  color: #333;
}

#approveTrack ul li.last {
  border-left-color: #ffffff;
}

#approveTrack ul li .node-icon {
  position: absolute;
  top: 2px;
  left: -8px;
  width: 15px;
  height: 15px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAAZ0lEQVR42mNgoCb48/v3/z/vP/z/8+wJAoP4QHHCGpE1oWNcBhDUiM8AZKf+vHDx/6v0rP/P3L3ANIiP7AVMzUimgzQ8trCGYxAfWR6vZpCNyJpBfKI1k24zRX6mJLQpimeKUxhdAQCutIJ1GkzzcQAAAABJRU5ErkJggg==');
}

#approveTrack .node-icon.first {
  padding-top: 0;
}

#approveTrack .date {
  display: inline-block;
  width: 130px;
}

#approveTrack .memo {
  color: #888888;
  word-break: break-all;
  padding-top: 5px;
  padding-left: 134px;
}
</style>



// WEBPACK FOOTER //
// progress.vue?7601be12